import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  constructor() {
    // TODO: REMOVE WHEN Deploying to PRD
    if(String.fromCodePoint!== undefined){
      console.info("Starting PGP Upgrade with net9.0 and angular 19.2. Have fun testing " + String.fromCodePoint(0x1F60A) +".");
    } else {
      console.info("Starting PGP Upgrade with net9.0 and angular 19.2. Have fun testing :) .");
    }
  }



}
